module.exports = __webpack_public_path__ + "456aeed2bbc2ed45f9d2f0f58edc66ed.png";